import React, {useContext, useEffect, useState} from 'react';
import {Col, Dropdown, Form, Spinner} from "react-bootstrap";
import {
    fetchAssTypes,
    updateAssType
} from "../../../http/bookAPI";
import Modal from "react-bootstrap/Modal";
import {Context} from "../../../index";
import {observer} from "mobx-react-lite";
import Row from "react-bootstrap/Row";

const UpdateAssignType = observer(({ show, handleClose }) => {
    const {book} = useContext(Context)

    const [atypeValue, setATypeValue] = useState('');
    const [atypeNameValue, setATypeNameValue] = useState('');
    const [atypeToDoValue, setATypeToDoValue] = useState('');
    const [atypePriceValue, setATypePriceValue] = useState('');
    const [atypePriceShiftValue, setATypePriceShiftValue] = useState('');

    // ✅ Новые состояния для промо-цены
    const [promoDiscount, setPromoDiscount] = useState("");
    const [promoDiscountStart, setPromoDiscountStart] = useState("");
    const [promoDiscountEnd, setPromoDiscountEnd] = useState("");

    const [promoBonus, setPromoBonus] = useState("");
    const [promoBonusStart, setPromoBonusStart] = useState("");
    const [promoBonusEnd, setPromoBonusEnd] = useState("");

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (show) {
            fetchAssTypes().then(data => book.setAssTypes(data));
        }
    }, [show]);


    const modifyAssType = async () => {
        if (!book?.selectedAssType?.id) {
            setError('Please select a Assign Type to modify.');
            return;
        }

        setLoading(true);
        setError('');
        try {
            // Логируем id и данные, которые отправляются в запросе
             await updateAssType({
                id: book?.selectedAssType?.id, // Используем выбранный
                ass_type: atypeValue,// Новое название
                ass_type_name: atypeNameValue,
                ass_type_todo: atypeToDoValue,
                ass_price: atypePriceValue,
                ass_price_shift: atypePriceShiftValue,
                 // ✅ Новые промо-данные
                 promotion_ass_price_discount: promoDiscount || 0,
                 promotion_ass_price_discount_start_date: promoDiscountStart ? Math.floor(new Date(promoDiscountStart).getTime()) : null,
                 promotion_ass_price_discount_end_date: promoDiscountEnd ? Math.floor(new Date(promoDiscountEnd).getTime()) : null,

                 promotion_ass_price_bonus: promoBonus || 0,
                 promotion_ass_price_bonus_start_date: promoBonusStart ? Math.floor(new Date(promoBonusStart).getTime()) : null,
                 promotion_ass_price_bonus_end_date: promoBonusEnd ? Math.floor(new Date(promoBonusEnd).getTime()) : null,


             });
            const updatedAssType = await fetchAssTypes(); // Обновляем список жанров после изменения
            book.setAssTypes(updatedAssType);
            // ✅ Очищаем поля после обновления



        } catch (e) {
            const errorMessage = e.response?.data?.message || 'An error occurred while modifying the Assign Type.';
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };


    return (
        <Modal show={show} onHide={() => {
            setError('');
            handleClose();
        }} centered size="xl">

            <div className="modal-content" >
                <div className="modal-header">
                    <h1 className="modal-title fs-5" id="exampleModalLabel">Edit Assignment Type:</h1>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => {
                            setError('');
                            handleClose();
                        }}
                    ></button>
                </div>

                <div className="card">
                    <div className="card-body">

                        <div className="d-flex justify-content-center mt-3">

                            <Dropdown className="dropdown-center">
                                <Dropdown.Toggle variant="success" className="shadow">
                                    {book?.selectedAssType?.ass_type_name || "Select Assign Type to Modify"}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {book?.asstypes.map((at) => (
                                        <Dropdown.Item
                                            onClick={() => {
                                                book?.setSelectedAssType(at);
                                                setATypeValue(at.ass_type);
                                                setATypeNameValue(at.ass_type_name);
                                                setATypeToDoValue(at.ass_type_todo);
                                                setATypePriceValue(at.ass_price);
                                                setATypePriceShiftValue(at.ass_price_shift);
                                                setPromoDiscount(at.promotion_ass_price_discount);
                                                setPromoDiscountStart(at.promotion_ass_price_discount_start_date);
                                                setPromoDiscountEnd(at.promotion_ass_price_discount_end_date);
                                                setPromoBonus(at.promotion_ass_price_bonus);
                                                setPromoBonusStart(at.promotion_ass_price_bonus_start_date);
                                                setPromoBonusEnd(at.promotion_ass_price_bonus_end_date);

                                            }}
                                            key={at.id}
                                        >
                                            {at.ass_type_name}

                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </div>
                <Row>
<Col>
    {error && <div className="alert alert-danger">{error}</div>}

    <Form.Group className="mb-2 mt-3 mx-3">
        <Form.Label className="small mb-1">Update Full Name of Assignment Type:</Form.Label>
        <Form.Control
            value={atypeNameValue}
            onChange={(e) => setATypeNameValue(e.target.value)}
            disabled={loading || !book?.selectedAssType?.ass_type_name}
        />
    </Form.Group>

    <Form.Group className="mb-2 mx-3">
        <Form.Label className="small mb-1">Update Short Name of Assignment Type:</Form.Label>
        <Form.Control
            value={atypeValue}
            onChange={(e) => setATypeValue(e.target.value)}
            disabled={loading || !book?.selectedAssType?.ass_type_name}
        />
    </Form.Group>

    <Form.Group className="mb-2 mx-3">
        <Form.Label className="small mb-1">Update ToDo of Assignment Type:</Form.Label>
        <Form.Control
            value={atypeToDoValue}
            onChange={(e) => setATypeToDoValue(e.target.value)}
            disabled={loading || !book?.selectedAssType?.ass_type_name}
        />
    </Form.Group>

    <Form.Group className="mb-2 mx-3">
        <Form.Label className="small mb-1">Update Default Price:</Form.Label>
        <Form.Control
            value={atypePriceValue}
            type="number"
            onChange={(e) => setATypePriceValue(e.target.value)}
            disabled={loading || !book?.selectedAssType?.ass_price}
        />
    </Form.Group>

    <Form.Group className="mb-4 mx-3">
        <Form.Label className="small mb-1">Update Default Price Shift:</Form.Label>
        <Form.Control
            value={atypePriceShiftValue}
            type="number"
            onChange={(e) => setATypePriceShiftValue(e.target.value)}
            disabled={loading || !book?.selectedAssType?.ass_price_shift}
        />
    </Form.Group>


</Col>
                <Col>


                    <Form.Group className="mb-2 mt-3 mx-3">
                        <Form.Label className="small mb-1">Update Promotion Discount:</Form.Label>
                        <Form.Control type="number" value={promoDiscount} onChange={(e) => setPromoDiscount(e.target.value)}
                                      disabled={loading || !book?.selectedAssType?.id} // Отключаем, если ничего не выбрано
                        />
                    </Form.Group>

                   <Row className="mb-2 mx-0">
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label className="small mb-1">Discount Start Date:</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={promoDiscountStart ? new Date(promoDiscountStart * 60000).toISOString().split("T")[0] : ""}
                                    onChange={(e) => setPromoDiscountStart(Math.floor(Date.parse(e.target.value) / 60000))}
                                    disabled={loading || !book?.selectedAssType?.id}
                                />
                            </Form.Group>

                        </Col>

                        <Col md={6}>
                            <Form.Group>
                                <Form.Label className="small mb-1">Discount End Date:</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={promoDiscountEnd ? new Date(promoDiscountEnd * 60000).toISOString().split("T")[0] : ""}
                                    onChange={(e) => setPromoDiscountEnd(Math.floor(Date.parse(e.target.value) / 60000))}
                                    disabled={loading || !book?.selectedAssType?.id}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Form.Group className="mb-2 mx-3">
                        <Form.Label className="small mb-1">Update Promotion Bonus:</Form.Label>
                        <Form.Control type="number" value={promoBonus} onChange={(e) => setPromoBonus(e.target.value)}
                                      disabled={loading || !book?.selectedAssType?.id} // Отключаем, если ничего не выбрано
                        />
                    </Form.Group>

                    <Row className="mb-2 mx-0">
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label className="small mb-1">Bonus Start Date:</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={promoBonusStart ? new Date(promoBonusStart * 60000).toISOString().split("T")[0] : ""}
                                    onChange={(e) => setPromoBonusStart(Math.floor(Date.parse(e.target.value) / 60000))}
                                    disabled={loading || !book?.selectedAssType?.id}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group>
                                <Form.Label className="small mb-1">Bonus End Date:</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={promoBonusEnd ? new Date(promoBonusEnd * 60000).toISOString().split("T")[0] : ""}
                                    onChange={(e) => setPromoBonusEnd(Math.floor(Date.parse(e.target.value) / 60000))}
                                    disabled={loading || !book?.selectedAssType?.id}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Form.Group className="mb-2 mt-3 mx-3">
                        <Form.Label className="small mb-1">Assignment ID: (This value cannot change here!)</Form.Label>
                        <Form.Control type="number" value={book?.selectedAssType?.id}
                                      disabled={true} // Отключаем, если ничего не выбрано// Отключаем, если ничего не выбрано
                        />
                    </Form.Group>



                </Col>
</Row>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                            setError('');
                            handleClose();
                        }}
                        disabled={loading}
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={modifyAssType}
                        disabled={!atypeNameValue.trim() || loading}
                    >
                        {loading ? <Spinner as="span" animation="border" size="sm"/> : 'Rewrite in DB'}
                    </button>

                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => {
                            modifyAssType();
                            book.setSelectedAssType({});
                            setATypeValue("");
                            setATypeNameValue("");
                            setATypeToDoValue("");
                            setATypePriceValue("");
                            setATypePriceShiftValue("");
                            setPromoDiscount("");
                            setPromoDiscountStart("");
                            setPromoDiscountEnd("");
                            setPromoBonus("");
                            setPromoBonusStart("");
                            setPromoBonusEnd("");
                            handleClose();
                        }}
                        disabled={!atypeNameValue.trim() || loading}
                    >
                        {loading ? <Spinner as="span" animation="border" size="sm"/> : 'Rewrite in DB and Close'}
                    </button>


                </div>
            </div>
        </Modal>
    );
});

export default UpdateAssignType;